export function expiryDateFromMinutes(minutes: number): Date {
  const now = new Date();
  const minutesInteger = Math.floor(minutes >= 0 ? minutes : 0);
  now.setMinutes(now.getMinutes() + minutesInteger);

  return now;
}
